import Vue from 'vue'
import stopIOSDoubleTapMixin from './stopIOSDoubleTapMixin'
import moment from 'moment'
Vue.mixin(stopIOSDoubleTapMixin)
Vue.mixin({
  filters: {
    dateTimeFmt (val) {
      if (val) {
        const mt = moment(val)
        if (mt.isValid()) {
          return mt.format('YYYY/MM/DD HH:mm:ss')
        }
      }
      return '--'
    },
    currencyFmt (val) {
      if (!val || isNaN(+val)) {
        return 0
      }
      // eslint-disable-next-line no-eval
      const currency = eval(Math.round((eval(val + 'e2'))) + 'e-2')
      return currency.toLocaleString()
    },
    dateFmt (val) {
      if (val) {
        const mt = moment(val)
        if (mt.isValid()) {
          return mt.format('YYYY/MM/DD')
        }
      }
      return '--'
    }
  },
  computed: {
    newAdd () {
      return this.$store.state.newAdd
    },
    area () {
      return this.$store.state.area
    }
  },
  methods: {
    phoneShow (val) {
      if (~this.$store.state.privileges.indexOf('customer.fullphone') || !(this.$store.state.privileges || []).length) {
        return val
      }
      if ((val || '').length >= 11) {
        return val.slice(0, 3) + '****' + val.slice(7, 11)
      }
      return val
    }
  }
})
